function replaceParams(path: string, params: Record<string, string | number>) {
  for (const key in params) {
    path = path.replaceAll(`:${key}`, params[key] as any);
  }
  return path;
}

export default replaceParams;
